import { Box } from '@mui/material';
import React from 'react';

import routes from '@/assets/constants/routes-no.ts';
import { ArrowLink } from '@/competitions/_common/components/ArrowLink.tsx';
import { sendUserPortalEvent } from '@/lib/analytics/unified.ts';
import type { CompetitionWithConfig } from '@/lib/api/requests.ts';
import { Timer, type TimerTheme } from '@/ui/Timer.tsx';

import { JUNE_2025_CAMPAIGN_END_DATE } from '../../../config.ts';
import { CTA } from '../_components/CTA.tsx';
import { Section } from '../_components/Section.tsx';

const dateFormatter = new Intl.DateTimeFormat('no', {
  day: 'numeric',
  month: 'long',
});
const dateStr = dateFormatter.format(JUNE_2025_CAMPAIGN_END_DATE);

const timerTheme: TimerTheme = {
  backgroundColor: '#355383',
  digitsColor: '#FFFFFF',
  labelsColor: '#F0F4FA',
};

export const TimerSection = (props: { activeCompetition: CompetitionWithConfig | undefined }) => {
  return (
    <Section
      sx={{
        gap: '20px',
        flexDirection: { md: 'row' },
        flexWrap: { md: 'wrap', xl: 'initial' },
        justifyContent: 'center',
      }}
    >
      <Box
        sx={{
          textAlign: { xs: 'center', xl: 'left' },
          flex: { xl: 1.15 },
          width: { md: '100%', xl: 'auto' },
          mb: { xs: 4, md: 2 },
          pr: { xl: 8 },
          mt: { xl: 4 },
        }}
      >
        <div className="mb-6 typography-v1-h1">Hvorfor lavere rente?</div>

        <p className="mx-auto mb-8 max-w-[70ch] typography-v1-body3">
          Vi vet at enda flere kan få lavere rente på sine forbrukslån og kredittkort. For å få enda
          flere til å sjekke lånene sine - og om de kan få lavere rente, har vi satt i gang en
          trekning for økt oppmerskomhet.
          <br />
          <br />
          For å delta i trekningen må du sjekke om du kan få lavere rente.
          <br />
          <br />
          Med lavere rente er det enklere å bli gjeldfri!
        </p>

        <div className="flex items-end gap-8">
          <CTA
            activeCompetition={props.activeCompetition}
            onClick={() => {
              sendUserPortalEvent('jun25_competition_cta_timer_clicked');
            }}
          />
        </div>
      </Box>
      <div className="mx-auto flex max-w-sm flex-1 flex-col rounded-lg bg-[#EFF7FF] p-6 md:max-w-md lg:mx-0 lg:max-w-xl">
        <p className="mb-4 typography-v1-h2">Premie</p>
        <p className="mb-2 typography-v1-h3">
          Ferie til en verdi av <span className="-mb-1 block typography-v1-h1">50 000 kr</span>
        </p>
        <p className="typography-v1-h3">
          +
          <br />
          pause fra gjelden din i
        </p>
        <p className="mb-2 block typography-v1-h1">et helt år</p>

        <p className="mt-auto mb-2 typography-v1-body3">
          Vi overtar regningene på rentebærende forbruks- og kredittkortgjeld i 12 mnd.
          <br />
          Maks. 50&nbsp;000&nbsp;kr
        </p>

        <ArrowLink
          to={routes.JUNE_2025_COMPETITION_TERMS}
          sx={{ display: 'block', my: 2, mt: { sm: 3 } }}
        >
          Vilkår og betingelser
        </ArrowLink>
      </div>
      <div className="mx-auto flex max-w-sm flex-1 flex-col rounded-lg bg-v1-background-200 p-6 text-white md:max-w-md lg:mx-0 lg:max-w-xl">
        <p className="typography-v1-h2">Trekningsdato</p>
        <Box
          component="p"
          className="mb-4 typography-v1-display"
          sx={{ fontSize: { lg: '3.812rem' } }}
        >
          {dateStr}
        </Box>
        <Timer date={JUNE_2025_CAMPAIGN_END_DATE} theme={timerTheme} />

        <p className="mt-6 mb-4 typography-v1-body3 md:mt-8 xl:mt-12">
          Vinnerne kontaktes via e-post og mobil.
          <br />
          Vi tar hensyn til personvern og publiserer ikke vinnere uten samtykke.
        </p>

        <ArrowLink
          to={routes.JUNE_2025_COMPETITION_TERMS}
          sx={{ display: 'block', my: 2, mt: { sm: 3 } }}
        >
          Vilkår og betingelser
        </ArrowLink>
      </div>
    </Section>
  );
};
